const NIPOSOM_DOMAINS = ["www.niposom.com", "www.niposom.pt"];
// Keep in sync with the transcoder defaults (TRANSCODER_MAX_WIDTH / _MAX_HEIGHT).
const CDN_MAX_WIDTH = 1920;
const CDN_MAX_HEIGHT = 1080;
// Mirrors the transcoder route: /webp/<w>[x<h>]/<path>
const SIZES_PATTERN = /^(\d{2,4})(?:x(\d{2,4}))?$/;

export function buildCdnImageUrl(
  src: string,
  sizes?: string,
  version?: number,
): string {
  if (!src || !sizes) return src;

  const sizesMatch = SIZES_PATTERN.exec(sizes);
  const width = Number(sizesMatch?.[1] ?? 0);
  const height = Number(sizesMatch?.[2] ?? 0);
  if (
    !sizesMatch ||
    width <= 0 ||
    width > CDN_MAX_WIDTH ||
    height > CDN_MAX_HEIGHT
  ) {
    return src;
  }

  const domain = NIPOSOM_DOMAINS.find((host) => src.includes(host));
  let imagePath: string | null = null;
  if (domain) {
    imagePath = src.substring(src.indexOf(domain) + domain.length + 1);
  } else if (src.includes("/static/") && !src.includes("localhost")) {
    imagePath = src.substring(src.indexOf("/static/") + "/static/".length);
  }
  if (imagePath === null) return src;

  // The transcoder ignores query strings; drop any source cache-buster so the
  // version we append is the only query parameter.
  const cleanPath = imagePath.split("?")[0];
  const url = `/webp/${sizes}/${cleanPath}`;
  return version ? `${url}?v=${version}` : url;
}
